import React from 'react';
import ReactDOM from 'react-dom';

// Redux
import { Provider } from 'react-redux';
import { store } from './store';

// Import (App)
import App from './App';
// import * as serviceWorker from './serviceWorker';

// Theme Loader
import themeLoader from './services/theme-loader';
import domainResolver from './lib/domain-resolver';
import performanceMonitor from './utils/performance-monitor';

// Initialize theme loader with Redux store
themeLoader.initialize(store);

// Debug: Log domain detection
const detectedDomain = domainResolver.getCurrentSlug();
console.log('[Theme Debug] Detected domain:', detectedDomain || 'none');
console.log('[Theme Debug] Current URL:', window.location.href);

// Initialize theme on startup (check cache first, load in background)
themeLoader.initializeOnStartup().catch(err => {
  console.error('Failed to initialize theme:', err);
});

// Expose for debugging in development
if (process.env.NODE_ENV === 'development') {
  window.__THEME_DEBUG__ = {
    loader: themeLoader,
    domainResolver,
    performanceMonitor,
    store
  };
  console.log('[Theme Debug] Debug tools available at window.__THEME_DEBUG__');
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.register();
